<script>
    import { onMount } from 'svelte'
    import {list_notebooks} from '../controller.js'
    import Nav from '../components/Nav.svelte'
    import Notebook from '../components/Notebook.svelte'
    import Search from '../components/Search.svelte'

    onMount(() => {
        function resize() {
            let totalHeight = window.visualViewport.height
            let totalWidth = window.visualViewport.width

            let nav = document.getElementById("nav")
            let container = document.getElementById("container")

            container.style.height = `${totalHeight - nav.clientHeight - 10}px`
            container.style.width = `${totalWidth - 10}px`
        }

        window.onresize = resize
        resize();
    })

</script>

<div id="everything">
    <div id="nav">
        <Nav />
    </div>

    <div id="container">
        <div class="box"><Search /></div>
        <div class="box"><Search /></div>
        <div class="box"><Search /></div>
        <div class="box"><Search /></div>
    </div>
</div>

<style>
#everything{
    height: 100%;
}
#container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 10px;
}
.box {
    border: 5px solid green;
    padding: 5px;
    overflow: auto;
}
</style>
